import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import SplitPDFImgeListScreen from "./SplitPDFImgeListScreen";
import LoadingBar from "react-top-loading-bar";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";

function SplitPDFMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Split PDF file" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/split_pdf", title: "PDF Splitter" },
    data2: { link: "/split_pdf", title: "Extract PDF pages" },
    data3: { link: "/split_pdf", title: "PDF Seperator" },
  };

  //reference loading bar
  const loadingBarRef = useRef(null);

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Split PDF files online easily. Separate pages, extract ranges, or divide PDFs quickly with our fast, secure, and simple PDF splitter tool."
      ></meta>
      <meta
        name="keywords"
        content="split pdf, split pdf online, pdf splitter, separate pdf pages, extract pdf pages, divide pdf files, pdf page splitter, split pdf tool, online pdf splitter, split pdf by pages, split pdf by range, pdf editor online, pdf management tool, split pdf free, pdf document splitter, split pdf into two pdfs,"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <SplitPDFImgeListScreen title={title} />
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Split PDF tool is a fast, secure, and easy-to-use online PDF splitter designed to help users efficiently split PDF files online without compromising quality or privacy, making it the perfect solution for students, professionals, and businesses who need to split large PDF documents, extract specific pages, or divide files into smaller, more manageable parts. With this powerful PDF split tool, you can quickly split PDF by page range, separate PDF pages, or extract pages from PDF files in just a few clicks, all directly from your browser with no software installation required. This free PDF splitter online works seamlessly across all devices and operating systems, including Windows, macOS, Android, and iOS, ensuring maximum compatibility and convenience. The tool preserves original formatting, layout, and quality while delivering high-speed processing, making it ideal for handling contracts, reports, invoices, eBooks, and scanned documents. Built with advanced security standards, our secure PDF splitting tool encrypts file transfers and automatically deletes uploaded documents after processing, ensuring complete data protection. Whether you need to split PDF into individual pages, create multiple PDFs from one file, or simply organize your documents more effectively, this best PDF splitter online offers a reliable, user-friendly, and professional solution to manage PDFs efficiently and save valuable time." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Convert",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Split PDF"
            why_use={[
              {
                title: "Easily Manage Large PDF Files",
                description:
                  "Split PDF tool helps users split large PDF files into smaller, more manageable documents, making storage, sharing, and organization much easier for both personal and professional use.",
              },
              {
                title: "Extract Specific Pages Quickly",
                description:
                  "With an advanced PDF splitter, you can extract pages from PDF files without editing the entire document, saving time when only certain pages are needed.",
              },
              {
                title: "Improve Document Sharing",
                description:
                  "By using an online PDF split tool, users can split PDF documents to share only relevant pages, reducing file size and improving email and upload efficiency.",
              },

              {
                title: "Enhance Workflow Efficiency",
                description:
                  "A reliable PDF split tool streamlines document workflows by allowing users to split PDF by page range or separate pages instantly, which is especially useful in offices and businesses.",
              },
              {
                title: "Maintain Original Quality and Format",
                description:
                  "The best PDF splitter ensures that text, images, and formatting remain intact when you split PDF files, delivering professional-quality results every time.",
              },
              {
                title: "Increase Data Security",
                description:
                  "Instead of sharing full documents, a secure PDF splitting tool lets users share only required pages, helping protect sensitive and confidential information.",
              },
              {
                title: "Free to Use",
                description:
                  "You don't need any account or sign up to start using our service. Very little time required to get your jobs done and the great part is it is free to use. And our app works completely offline.",
              },
              {
                title: "Save Time and Resources",
                description:
                  "Using a free PDF splitter online or offline solution eliminates the need for re-creating documents, making PDF splitting a fast and cost-effective process.",
              },
              {
                title: "Work Across Devices and Platforms",
                description:
                  "Modern PDF split tools work on multiple devices and operating systems, allowing users to split PDF files online or offline anytime, anywhere.",
              },
            ]}
          />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${6504000491}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default SplitPDFMain;
